import type { GameModule } from '../../core/contracts'
import {
  INITIAL_LEVEL,
  MAX_LEVEL,
  MIN_LEVEL,
  REFERENCE_RT_MS,
  evaluate,
  generateRound,
} from './logic'
import type { MatrixAnswer, MatrixRound } from './logic'
import { MemoryMatrixView } from './view'

/**
 * Манифест игры. Всё, что движок знает про Memory Matrix.
 * Подключается одной строкой в registry.ts.
 */
export const memoryMatrix: GameModule<MatrixRound, MatrixAnswer> = {
  id: 'memory-matrix',
  titleKey: 'game.memoryMatrix',
  hintKey: 'game.memoryMatrix.hint',
  discipline: 'memory',
  metric: 'span',
  difficulty: { min: MIN_LEVEL, max: MAX_LEVEL, initial: INITIAL_LEVEL },
  roundsPerSession: 5,
  referenceRtMs: REFERENCE_RT_MS,
  generateRound,
  evaluate,
  View: MemoryMatrixView,
}

export * from './logic'
